import { FC } from 'react';

import { HSpacing, HSpacingContainer } from '@hh.ru/magritte-ui';
import debounce from 'bloko/common/debounce';
import useResize from 'bloko/common/hooks/useResize';
import { Breakpoint, getBreakpoint } from 'bloko/common/media';

import ApplicantActivityCard from 'src/components/Applicant/ActivityCard';
import SearchOrder from 'src/components/SearchSorts/SearchOrder';
import SearchPeriod from 'src/components/SearchSorts/SearchPeriod';
import useToggleSearchPreference from 'src/components/SearchSorts/hooks/useToggleSearchPreference';

import SearchViewSwitcher from 'src/components/VacancySearchContent/components/SearchViewSwitcher';

const RESIZE_SEARCH_SETTINGS_DEBOUNCE = 200;

const Settings: FC = () => {
    const toggleSearchPreference = useToggleSearchPreference();

    const debouncedResizeSettings = debounce(() => {
        const breakpoint = getBreakpoint();
        if ([Breakpoint.M, Breakpoint.L].includes(breakpoint)) {
            toggleSearchPreference(false);
        }
    }, RESIZE_SEARCH_SETTINGS_DEBOUNCE);

    useResize(debouncedResizeSettings);

    return (
        <div className="search-filters" data-qa="serp__settings">
            <div className="search-filters__sorts">
                <div className="search-filters__item">
                    <SearchOrder />
                </div>
                <HSpacing default={60} />
                <div className="search-filters__item">
                    <SearchPeriod />
                </div>
            </div>

            <HSpacingContainer default={24}>
                <ApplicantActivityCard variant="compact" iconType="info" width={270} />
                <SearchViewSwitcher />
            </HSpacingContainer>
        </div>
    );
};

export default Settings;
